<script setup>
import { computed } from 'vue';

const props = defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  error: {
    type: [String, Error, null],
    default: null
  },
  loadingText: {
    type: String,
    default: 'Loading...'
  }
});

const hasError = computed(() => props.error !== null);
const errorMessage = computed(() => {
  if (!props.error) return '';
  return props.error instanceof Error ? props.error.message : props.error;
});
</script>

<template>
  <div class="relative">
    <!-- Loading overlay -->
    <div
      v-if="loading"
      class="absolute inset-0 z-50 flex items-center justify-center bg-white bg-opacity-75"
    >
      <div class="text-center">
        <div class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
        <p class="mt-2 text-sm text-gray-600">{{ loadingText }}</p>
      </div>
    </div>

    <!-- Error state -->
    <div
      v-if="hasError"
      class="rounded-md bg-danger-50 p-4"
    >
      <div class="flex">
        <div class="flex-shrink-0">
          <svg class="h-5 w-5 text-danger-400" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
          </svg>
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium text-red-800">Error</h3>
          <div class="mt-2 text-sm text-danger-700">
            <p>{{ errorMessage }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div :class="{ 'opacity-50': loading }">
      <slot></slot>
    </div>
  </div>
</template> 